module.exports = __webpack_public_path__ + "static/media/TricloroTableta.e8df21a8.png";